export function standardFilterFn(row, id, value) {
    return value.includes(row.getValue(id));
}
export function arrayFilterFn(row, id, value) {
    return value.some((v) => row.getValue(id).includes(v));
}
